import { Modal, Message } from '@arco-design/web-react'
import { useTranslation } from 'react-i18next'
import { deleteUserApi } from '@/api/user'
import { useAuthStore } from '@/stores/authStore'
import { useNavigate } from 'react-router-dom'

interface DeleteAccountModalProps {
  visible: boolean
  onClose: () => void
  runSecure: <T>(fn: () => Promise<T>) => Promise<T>
}

export default function DeleteAccountModal({ visible, onClose, runSecure }: DeleteAccountModalProps) {
  const { t } = useTranslation()
  const logout = useAuthStore((s) => s.logout)
  const navigate = useNavigate()

  const confirm = () => {
    Modal.confirm({
      title: t('personal.danger.deleteConfirmTitle'),
      content: t('personal.danger.deleteConfirmContent'),
      okButtonProps: { status: 'danger' },
      onOk: async () => {
        try {
          await runSecure(() => deleteUserApi())
          Message.success(t('personal.danger.deleteSuccess'))
          logout()
          navigate('/')
        } catch (err: unknown) {
          if (err instanceof Error && err.message !== t('用户取消了二次验证')) {
            Message.error(err.message)
          }
        }
      },
    })
    onClose()
  }

  return (
    <Modal visible={visible} onCancel={onClose} onOk={confirm} okButtonProps={{ status: 'danger' }} title={t('personal.danger.deleteAccount')}>
      <p className="text-sm text-[var(--console-text-muted)]">{t('personal.danger.deleteConfirmContent')}</p>
    </Modal>
  )
}
